<template lang="pug">
  .component-selectize-client
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Client", @itemRemoved="optionRemoved")
</template>

<script>
  import Selectize from "../../../Selectize";
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";

  export default {
    name: "SelectizeClient",
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'organization_name']
      }
    },
    created() {
      KeplerBackofficeSdk.selects.clients((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>C${item.id}</small></div><div>${item.organization_name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>${item.organization_name}</div>`
      },
      clearSelected() {
        this.$refs.selectize.clearSelected()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeClient.vue?67051c96